module.exports = __webpack_public_path__ + "static/media/image_Male_Active.6b632efe.svg";